var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('login-lessee-dialog'),(_vm.message.show)?_c('my-message-send'):_vm._e(),(_vm.$store.state.isLogin && _vm.$store.state.aiChatEnabled === '1')?_c('ws-customer-service'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }